import React from "react";

import { ViewportProps } from "react-map-gl";

import { Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import { useAppDispatch } from "store";
import { setViewport } from "modules/customer/tools/location/locationSlice";
import { Coordinates } from "modules/customer/tools/location/suggestedNewLocations/suggestedNewLocation";
import { hideSuggestedNewLocations } from "modules/customer/tools/location/suggestedNewLocations/suggestedNewLocationsSlice";

const StyledButton = withStyles(theme => ({
    root: {
        // @ts-ignore
        color: theme.palette.tertiary.main,
        // @ts-ignore
        backgroundColor: "transparent",
        "&:hover": {
            // @ts-ignore
            color: theme.palette.tertiary.main,
            // @ts-ignore
            backgroundColor: "transparent",
        }
    }
}))(Button);

interface ExploreLocationProps {
    coordinates: Coordinates
}

const ExploreLocation: React.FC<ExploreLocationProps> = (props) => {
    const { coordinates } = props;
    const dispatch = useAppDispatch();

    const handleClick = () => {
        const viewport: ViewportProps = {
            latitude: coordinates.latitude,
            longitude: coordinates.longitude,
            zoom: 17,
            minZoom: 5.5
        };
        dispatch(setViewport(viewport));
        dispatch(hideSuggestedNewLocations());
    };

    return (
        <StyledButton
            variant="text"
            size="medium"
            color="default"
            disableElevation
            onClick={handleClick}
            data-cy="btn-suggested-new-locations-view-location"
        >
            View location
        </StyledButton>
    );
};

export default ExploreLocation;
